import * as Yup from "yup";
import { FIELD_REQUIRED_MESSAGE } from "../utils/validations";

export const userInitialValues = {
  profile_avatar: null,
  name: "",
  role: "Client",
  phone: "",
  email: "",
  address: "",
  country: "",
  state: "",
  city: "",
  postal_code: "",
  dni: "",
  occupation: "",
  occupation_description: "",
  company: "",
  birthday: "",
  age: 0,
  is_chat_responsible: false,
  sex: "",
  objective: "",
  terms: false,
  gym_id: "",
  branch_id: "",
  accept_clauses: true,
  sufficiently_informed: true,
  receive_communications: true,
  image_rights: true,
};

export const userValidationSchema = Yup.object({
  profile_avatar: Yup.mixed().nullable(),
  name: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  role: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  phone: Yup.string().optional().nullable(),
  email: Yup.string().email("Email inválido").required(FIELD_REQUIRED_MESSAGE),
  birthday: Yup.date().required(FIELD_REQUIRED_MESSAGE),
  sex: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  objective: Yup.string().optional(),
  terms: Yup.boolean().oneOf([true], "Debe aceptar los términos y condiciones"),

  gym_id: Yup.number().required(FIELD_REQUIRED_MESSAGE),
  branch_id: Yup.number().required(FIELD_REQUIRED_MESSAGE),

  accept_clauses: Yup.boolean().oneOf([true], "Debe aceptar las cláusulas"),
  sufficiently_informed: Yup.boolean().oneOf(
    [true],
    "Debe estar suficientemente informado"
  ),
  receive_communications: Yup.boolean().optional(),
  image_rights: Yup.boolean().optional(),
});

export type UserValues = typeof userInitialValues;
